import React, { useState, useEffect } from "react";
import { observer } from "mobx-react-lite";
import blockStore from "../../Store/BlockStore";
import {
  Box,
  Modal,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  IconButton,
  CircularProgress,
  Button,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import ArrowDownward from "@mui/icons-material/ArrowDownward";
import { toast } from "react-toastify";

const ManageBlockModal = observer(
  ({ open, handleClose, block, blockStore }) => {
    const [moviesInBlock, setMoviesInBlock] = useState([]);

    // Загрузка фильмов блока
    useEffect(() => {
      if (open && block) {
        console.log("Открыта модалка блока, block_id =", block.block_id);
        blockStore.getMoviesInBlock(block.block_id);
      }
    }, [open, block]);

    // Обновление списка фильмов
    useEffect(() => {
      if (blockStore.responseMoviesInBlock?.data) {
        setMoviesInBlock(blockStore.responseMoviesInBlock.data);
      }
    }, [blockStore.responseMoviesInBlock]);

    const handleRemoveFromBlock = async (recordId) => {
      if (!recordId || !block) return;
      if (!window.confirm("Удалить фильм из блока?")) return;

      try {
        await blockStore.removeMovieFromBlock(recordId, block.block_id);
        await blockStore.getMoviesInBlock(block.block_id);
        toast.success("Фильм удалён из блока");
      } catch (error) {
        toast.error("Не удалось удалить фильм");
      }
    };

    const handleMoveDown = async (recordId) => {
      if (!recordId || !block) return;
      try {
        await blockStore.moveMovieDown(recordId, block.block_id);
        await blockStore.getMoviesInBlock(block.block_id);
        toast.success("Фильм опущен вниз");
      } catch (error) {
        toast.error("Не удалось опустить фильм");
      }
    };

    if (!block) return null;

    return (
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 650,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
            maxHeight: "90vh",
            overflowY: "auto",
            overflowX: "hidden", // ← Добавлено
          }}
        >
          <Paper sx={{ p: 2, mb: 3, backgroundColor: "#E0F7FA" }}>
            <Typography variant="h6" align="center">
              {block.name}
            </Typography>
          </Paper>

          <TableContainer component={Paper} variant="outlined">
            <Table size="small">
              <TableBody>
                {blockStore.loading ? (
                  <TableRow>
                    <TableCell colSpan={3} align="center" sx={{ py: 4 }}>
                      <CircularProgress size={28} />
                    </TableCell>
                  </TableRow>
                ) : moviesInBlock.length > 0 ? (
                  moviesInBlock.map((film) => (
                    <TableRow
                      key={film.id}
                      sx={{
                        height: "20px",
                        "& td, & th": { padding: "4px" },
                      }}
                    >
                      <TableCell>
                        {film.title ||
                          film.movie?.title ||
                          `Фильм ${film.movie_id}`}
                      </TableCell>

                      <TableCell align="right">
                        <IconButton
                          color="primary"
                          size="small"
                          onClick={() => handleMoveDown(film.id)}
                          title="Опустить вниз"
                        >
                          <ArrowDownward />
                        </IconButton>
                      </TableCell>

                      <TableCell align="right">
                        <IconButton
                          color="error"
                          size="small"
                          onClick={() => handleRemoveFromBlock(film.id)}
                          title="Удалить из блока"
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={3} align="center">
                      В блоке пока нет фильмов
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <Box sx={{ mt: 4, textAlign: "center" }}>
            <Button variant="outlined" onClick={handleClose}>
              Закрыть
            </Button>
          </Box>
        </Box>
      </Modal>
    );
  }
);

export default ManageBlockModal;
